import type { VaultV2ExposureTab } from '../hooks/useVaultV2ExposureData'

export type ExposureTabKey = VaultV2ExposureTab | 'PublicAllocator'

export const EXPOSURE_TABS: { key: ExposureTabKey; label: string }[] = [
  { key: 'VaultsAndMarkets', label: 'Markets' },
  { key: 'Collateral', label: 'Collateral' },
  { key: 'Adapters', label: 'Adapters' },
  { key: 'PublicAllocator', label: 'Public Allocator' }
]
